"use client";

import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyMeTeacherResourceAccess: BaseKeyFunction = () => [
  "me",
  "access",
  "teacher-resource",
];
